// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import {  } from '../fnc.js'
import Loading from '../Pages/ctn/Loading';
import PoList from './ctn/Reordering/PoList.js'
import Pagination from './ctn/eBay/Pagination.js'
import $ from 'jquery';
import PoShowListItems from './ctn/Reordering/PoShowListItemsv2.js'
const refConst = require("../constants.js").v

const initialState = {
	accountAccepted: false,
	products: {},
	pmaData: [],
	pmaStores: [],
	currentAccountLines: [],
	lineAccess: {from: null, to: null},
	dataNumber: null,
	pma: null
}

export default function Reordering(props){

	const adminAccess = [
		"-MjVxK86GVBUKL5oNU66", // General admin
	]

	if(!props.securityClearance(props))	return;

	const qtyPerPage = 500;
	const [version] = useState("0.1.0");
	const [selectedIdSupplier, setSelectedIdSupplier] = useState(props.parent.match.params.idSupplier);

	useEffect(() => {
		$('.tooltipInfo').tooltip({
			placement: "right",
			template:  '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner tooltip-info-ebay"></div></div>',
		}).tooltip('update')

		$('.tooltipInfo').on('click', function() {
			$('.tooltip').tooltip('hide');
		});
	})

	useEffect(() => {
		setSelectedIdSupplier(props.parent.match?.params?.idSupplier)
	}, [props.parent.match?.params?.idSupplier])

	console.info("selectedIdSupplier", selectedIdSupplier);

	if(selectedIdSupplier){
		return <PoShowListItems
			{...props}
			selectedIdPo={selectedIdSupplier}
			setSelectedPo={setSelectedIdSupplier}
			title={selectedIdSupplier.supplier_name || selectedIdSupplier.id_supplier}
			data={selectedIdSupplier}
		/>
	}else
		return (<div>
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<h1>Reordering</h1>
					</div>
				</div>
				<PoList
					{...props}
				/>
			</div>
		</div>);
}